import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from 'react-router-dom'

import { AdminLayout } from '~/layout/admin'
import { LayoutProvider } from '~/layout/personalTrainer/PersonalTrainerAreaLayout'
import { authenticationAtom } from '~/modules/authentication/data'
import { useAtom } from '~/observers/jotai'
import { Actions } from '~/pages/authenticated/admin/actions'
import { Administrators } from '~/pages/authenticated/admin/administrators'
import { Dashboard } from '~/pages/authenticated/admin/dashboard'
import { AdminHome } from '~/pages/authenticated/admin/home'
import { Licenses } from '~/pages/authenticated/admin/Licenses'
import { Profile } from '~/pages/authenticated/admin/profile'
import { Sales } from '~/pages/authenticated/admin/Sales'
import { AdminSettings } from '~/pages/authenticated/admin/settings'
import { PersonalTrainerHome } from '~/pages/authenticated/personalTrainer/home'
import { Offers } from '~/pages/authenticated/personalTrainer/Offers'
import { PersonalTrainerRecoverPassword } from '~/pages/authenticated/personalTrainer/PersonalTrainerRecoverPassword'
import { PersonalTrainerProfile } from '~/pages/authenticated/personalTrainer/profile'
import { StudentEvaluation } from '~/pages/authenticated/personalTrainer/studentEvaluation'
import { StudentEvaluationDemo } from '~/pages/authenticated/personalTrainer/studentEvaluationDemo'
import { Subscriptions } from '~/pages/authenticated/personalTrainer/Subscriptions'
import { PersonalTrainerSignUp } from '~/pages/authenticated/personalTrainerSignUp'
import { PrintPages } from '~/pages/authenticated/printPages'
import { AdminLogin } from '~/pages/open/AdminLogin'
import { PersonalTrainerLogin } from '~/pages/open/personalTrainerLogin'
import { SubscriptionsCheckout } from '~/pages/open/SubscriptionsCheckout'
import { TrialRegister } from '~/pages/open/TrialRegister'

import {
  adminLoginRoute,
  demoStudentEvaluationsRoute,
  getPrintPagesRoute,
  personalTrainerLoginRoute,
  personalTrainerProfileRoute,
  personalTrainerRecoverPasswordRoute,
  personalTrainerSubscriptionOffersRoute,
  personalTrainerSubscriptionsRoute,
  planCheckoutRoute,
  registerTrialRoute,
  signUpRoute,
  studentEvaluationsRoute,
} from './routes'

export const AppRouter: React.FC = () => {
  const [session] = useAtom(authenticationAtom)

  const personalTrainerArea = (
    <>
      <Route path={getPrintPagesRoute()} element={<PrintPages />} />
      <Route
        path='/*'
        element={
          <LayoutProvider>
            <Outlet />
          </LayoutProvider>
        }
      >
        <Route path='/*/painel' element={<PersonalTrainerHome />} />
        <Route
          path={`/*/${personalTrainerSubscriptionsRoute}`}
          element={<Subscriptions />}
        />

        <Route
          path={`/*/${studentEvaluationsRoute}/*`}
          element={<StudentEvaluation />}
        />
        <Route
          path={`/*/${demoStudentEvaluationsRoute}/*`}
          element={<StudentEvaluationDemo />}
        />
        <Route
          path={`/*/${personalTrainerProfileRoute}`}
          element={<PersonalTrainerProfile />}
        />
        <Route path='/*/print' element={<PrintPages />} />
        <Route path='*' element={<Navigate to='/painel' replace />} />
      </Route>
    </>
  )

  return (
    <BrowserRouter>
      <Routes>
        {session ? (
          session.role === 'admin' ? (
            <>
              <Route
                path='/admin/*'
                element={
                  <AdminLayout>
                    <Outlet />
                  </AdminLayout>
                }
              >
                <Route path='personal-trainers' element={<AdminHome />} />
                <Route path='painel' element={<Dashboard />} />
                <Route path='vendas/*' element={<Sales />} />
                <Route path='licencas/*' element={<Licenses />} />
                <Route path='configuracoes' element={<AdminSettings />} />
                <Route path='actions' element={<Actions />} />
                <Route path='administradores' element={<Administrators />} />
                <Route path='perfil' element={<Profile />} />
                <Route
                  path='*'
                  element={
                    <Navigate to='/admin/personal-trainers' replace />
                  }
                />
              </Route>
              {personalTrainerArea}
            </>
          ) : (
            personalTrainerArea
          )
        ) : (
          <>
            <Route
              path={personalTrainerLoginRoute}
              element={<PersonalTrainerLogin />}
            />
            <Route path={adminLoginRoute} element={<AdminLogin />} />
            <Route path={signUpRoute} element={<PersonalTrainerSignUp />} />
            <Route
              path={personalTrainerRecoverPasswordRoute}
              element={<PersonalTrainerRecoverPassword />}
            />
            <Route
              path='/*'
              element={<Navigate to={personalTrainerLoginRoute} replace />}
            />
          </>
        )}

        <Route
          path={personalTrainerSubscriptionOffersRoute}
          element={<Offers />}
        />
        <Route path={planCheckoutRoute} element={<SubscriptionsCheckout />} />

        <Route path={registerTrialRoute} element={<TrialRegister />} />
      </Routes>
    </BrowserRouter>
  )
}
